import {useState} from 'react';
import {TableRow, TableCell, MenuItem} from '@mui/material';
import {useMutation} from "@tanstack/react-query";
import {useTranslation} from 'react-i18next';
import {TableMoreMenu} from '../../../../components/table';
import {LoadingButton} from "@mui/lab";
import {changeGeofenceActiveState} from "../../../../services/geofanceServices";
import {snackActions} from "../../../../components/notistack/SnackbarUtilsConfigurator";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


const GeoTableRow = ({
                         row,
                         selected,
                         onEditRow,
                         onDeleteRow,
                         setTableData,
                     }) => {
    const {t} = useTranslation();
    const {name, is_active: isActive, id} = row;
    const geofanceRequesthandler = useMutation({
        mutationFn: () => changeGeofenceActiveState(id, {is_active: !isActive}),
        onSuccess: (data) => {
            snackActions.success(data?.data?.message);
            setTableData(data.data.data.geofences);
        },
    });
    const [openMenu, setOpenMenuActions] = useState(null);

    const handleOpenMenu = (event) => {
        setOpenMenuActions(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    return (
        <TableRow  hover selected={selected}  sx={ {
            '&:nth-of-type(odd)': {
                bgcolor: 'background.neutral' ,
            },
            '&:nth-of-type(even)': {
                bgcolor: 'background' ,
            },
            
          }}>
            {/*<TableCell padding="checkbox">*/}
            {/*  <Checkbox checked={selected} onClick={onSelectRow} />*/}
            {/*</TableCell>*/}

            <TableCell sx={{display: 'flex', alignItems: 'center'}}>{name}</TableCell>
            <TableCell align="left">
                <LoadingButton variant={'contained'} color={isActive ? 'success' : 'error'}
                               loading={geofanceRequesthandler.isLoading}
                               onClick={() => geofanceRequesthandler.mutate()}>
                    {isActive ? 'فعال' : 'غیر فعال'}
                </LoadingButton>
            </TableCell>

            <TableCell align="right">
                <TableMoreMenu
                    open={openMenu}
                    onOpen={handleOpenMenu}
                    onClose={handleCloseMenu}
                    actions={
                        <>
                            <MenuItem
                                onClick={() => {
                                    onDeleteRow();
                                    handleCloseMenu();
                                }}
                                sx={{color: 'error.main'}}
                            >
                           <DeleteIcon style={{ width: '1.2rem' }} />
                                {t('Delete')}
                            </MenuItem>

                            <MenuItem
                                onClick={() => {
                                    onEditRow();
                                    handleCloseMenu();
                                }}
                            >
                                <EditIcon/>
                                {t('Edit')}
                            </MenuItem>
                        </>
                    }
                />
            </TableCell>
        </TableRow>
    );
}


export default GeoTableRow